import { celebrate } from './modules/confetti'

export function showConfetti() {
    celebrate()
}
